import type { RemoteMessage, ActorReference } from "./contracts"
import type { Message } from "./model"

export const communicationActorId = (actor: ActorReference) => actor.kind === "ai" ? actor.id === "chatgpt" ? "chatgpt" : "ai" : actor.kind === "system" && actor.id === "danaro" ? "system" : `${actor.kind}:${actor.id}`

/** Presentation only: identity lifecycle, fetching, and write acknowledgments stay in the store. */
export function presentRemoteMessage(row: RemoteMessage, attachmentUrl: (id: string) => string): Message {
  const attachments = row.attachments ?? []
  const audio = attachments.find(file => file.id === row.voice?.attachmentId)
  return {
    id: row.id, author: communicationActorId(row.author), text: row.body, at: new Date(row.createdAt).getTime(), visibility: row.visibility,
    delivery: row.deliveryStatus === "accepted" ? "sent" : row.deliveryStatus, transport: row.transport, senderEmail: row.senderEmail,
    deliveryErrorCode: row.deliveryErrorCode, attachmentNotice: row.attachmentNotice, aiActions: row.aiActions ?? [], aiEvidence: row.aiEvidence ?? [], aiFeedback: row.aiFeedback,
    attachments: attachments.filter(file => file.id !== row.voice?.attachmentId).map(file => ({ ...file, url: attachmentUrl(file.id) })),
    ...(row.voice ? { voice: { id: row.id, duration: row.voice.duration, waveform: row.voice.waveform, audioUrl: audio ? attachmentUrl(audio.id) : undefined, mimeType: audio?.type } } : {}),
    reactions: (row.reactions ?? []).map(reaction => ({ emoji: reaction.emoji, by: reaction.by.map(communicationActorId) })),
  }
}
